
import dust from "dustjs-linkedin";


(function(){dust.register("lessons/lesson-creator/editor",body_0);function body_0(chk,ctx){return chk.write("<div class=\"header\"></div><main></main><div class=\"notification-container\"></div>");}return body_0;})();

export default 0;
